<template>
    <button class="user-activity__toggle" :class="{ 'user-activity__toggle--desktop': isDesktopDevice }"
        @click="toggleDrawer">


        <span class="user-activity__toggle-text" v-if="isDesktopDevice">
            Live Activity
        </span>

        <span class="user-activity__toggle-arrow" :style="{ transform: `rotate(${openDrawer ? '270deg' : '90deg'})` }">
            <collapse-arrow></collapse-arrow>
        </span>


    </button>
</template>



<script lang="ts" setup>

import { inject } from "vue";
import { isDesktop } from "@/utils/utils";
import CollapseArrow from '@/icons/CollapseArrow.vue';

const isDesktopDevice = isDesktop();
const openDrawer = inject('openDrawer');

const toggleDrawer = () => {
  openDrawer.value = !openDrawer.value;
};

</script>